module.exports = __webpack_public_path__ + "src/assets/img/engine_three.38763eab.svg";